import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { API_BASE_URL, tokenStorage } from '../api/client';

// Reverb speaks the Pusher protocol, so we use pusher-js as the client.
// The app key/host/port match the REVERB_* vars in base/.env.
//
// Auth for private channels goes through /api/v1/broadcasting/auth with
// the Sanctum bearer token (see routes/api.php). Laravel Echo will POST
// there automatically when subscribing to a private-* channel.

// `Pusher` must be on window for Echo to find it (laravel-echo convention).
(window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher;

let instance: Echo<'reverb'> | null = null;

export function getEcho(): Echo<'reverb'> | null {
  if (instance) return instance;

  const key = process.env.REACT_APP_REVERB_APP_KEY;
  const host = process.env.REACT_APP_REVERB_HOST ?? 'localhost';
  const port = Number(process.env.REACT_APP_REVERB_PORT ?? 8080);
  const scheme = process.env.REACT_APP_REVERB_SCHEME ?? 'http';

  if (!key) {
    // No Reverb key configured — app falls back to polling only.
    return null;
  }

  instance = new Echo({
    broadcaster: 'reverb',
    key,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${API_BASE_URL}/api/v1/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${tokenStorage.get() ?? ''}`,
        Accept: 'application/json',
      },
    },
  });

  return instance;
}

export function disconnectEcho(): void {
  if (instance) {
    instance.disconnect();
    instance = null;
  }
}
